import Header from "./header";

// Site header functions
const siteHeader = document.querySelectorAll("#siteHeader");
siteHeader.forEach((header) => {
	Header(header);
});
